const CONSTANTS = {

    FOOTER_TELL_US_URL: "https://feedback.employeehub.autodesk.com",

    EMPLOYEE_HUB_SLACK_URL: "https://autodesk.slack.com/app_redirect?channel=C6C75BM9A",
    
    TWO_STEP_DESC_TEXT: "Adds an extra layer of security to your Autodesk account and is required when logging in to most Autodesk services",

    AUTHENTICATOR_DESC_TEXT: "If you have already registered with Microsoft Authenticator and replaced your phone or reinstalled the app, follow the steps below. You will need both your previous and new device.",
    
    AUTHENTICATOR_STEPS: [
        'Go to the Microsoft <a class="mixpanel-link" target="_blank" href="https://mysignins.microsoft.com/security-info">My sign-ins page</a>.',
        "Complete two-step verification using your previous device.",
        'Click <b>Add sign-in method</b> to add your new mobile device.',
        'Select <b>Authenticator app</b> from the drop-down and follow the prompts.'
    ],

};

export default CONSTANTS;